import React from 'react';
import { DataList, CustomModal, Loader } from 'commons-ui';
import { useStyletron } from 'baseui';
import useDashboardActions from 'pages/userProfile/useUserProfileActions';
import { LIST_ENTITY_NAMES } from 'constant';
import { Button, KIND, SIZE, SHAPE } from 'baseui/button';

import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { columnConfigs } from './listConfig';

const RefundRequestList: React.FC<{}> = () => {
	const {
		getAllRefundRequestData,
		handleFilterModalOpen,
		handleRefundsDownloadModalOpen,
		approveAndRefundRequestInBulk,
		showLoader,
		forceUpdate,
		pageNumber,
		filters,
		jumpBack,
		jumpNext,
		setShowLoader
	} = useService();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, {
		approveAndRefundRequestInBulk,
		setShowLoader,
		filters
	});
	const actions = getActionList();
	const [css] = useStyletron();
	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					gap: '20px'
				})}>
				<Button
					kind={KIND.primary}
					size={SIZE.compact}
					onClick={() => {
						handleFilterModalOpen();
					}}>
					Change Filters
				</Button>
				<Button
					kind={KIND.primary}
					size={SIZE.compact}
					onClick={() => {
						handleRefundsDownloadModalOpen();
					}}>
					Download Refunds CSV
				</Button>
				<div title='pagination' className={css({ padding: '6px 200px' })}>
					{pageNumber.currPage > 1 && (
						<Button
							kind={KIND.secondary}
							size={SIZE.compact}
							shape={SHAPE.pill}
							onClick={() => {
								jumpBack();
							}}>
							← Prev Page
						</Button>
					)}
					{pageNumber.nextPage !== null && (
						<Button
							kind={KIND.secondary}
							size={SIZE.compact}
							shape={SHAPE.pill}
							onClick={() => {
								jumpNext();
							}}>
							Next Page →
						</Button>
					)}
				</div>
			</div>
			<DataList
				fetchData={getAllRefundRequestData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.REFUND_REQUEST}
				height='calc(100vh - 220px)'
				showFooterMessage={false}
				disablePagination
				globalForceUpdate={forceUpdate}
			/>
			<CustomModal />
		</>
	);
};

export default RefundRequestList;
